import { Box, Button, Typography } from "@mui/material";
import { ReactNode } from "react";
import DragIndicatorIconSvg from "@/components/common/icons/dragIndicatorIconSvg";
import { GREY, PRIMARY, VIOLET } from "@/config/mui/colorPalette";

export default function DefaultItemRenderer({
  content,
  selected,
  enabled,
  isNested = false,
}: {
  content: ReactNode;
  selected: boolean;
  enabled: boolean;
  isNested?: boolean;
}) {
  const backgroundColorForNotSelected = isNested ? GREY[15] : GREY[5];
  const backgroundColorForSelected = VIOLET[40];
  const backgroundColor = selected
    ? backgroundColorForSelected
    : backgroundColorForNotSelected;

  const cursorForEnabled = selected ? "grabbing" : "grab";
  const cursorForDisabled = "not-allowed";
  const cursor = enabled ? cursorForEnabled : cursorForDisabled;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        backgroundColor,
        cursor,
        color: isNested ? GREY[80] : "inherit",
        minHeight: "32px",
        borderRadius: "8px",
        transition: "background-color 0.2s",
        p: 1.5,
      }}
    >
      <Button
        disableRipple
        disabled
        sx={{
          minWidth: "24px",
          minHeight: "24px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          mr: 1,
          p: 0,
          backgroundColor: "transparent",
        }}
      >
        <DragIndicatorIconSvg
          size="24px"
          color={selected ? PRIMARY : GREY[40]}
        />
      </Button>
      <Typography
        variant="paragraphSmall"
        sx={{ textAlign: isNested ? "left" : "inherit" }}
      >
        {content}
      </Typography>
    </Box>
  );
}
